var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._b({attrs:{"visible":_vm.visible,"custom-class":"common-dialog"},on:{"update:visible":function($event){_vm.visible=$event}}},'el-dialog',_vm.$attrs,false),[_vm._t("default"),(_vm.$slots.footer)?[_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }